export default {
  namespaced: true,
  state: () => ({
    active: false,
    // Single-item compat (kept for legacy reads)
    itemId: null,
    // All item IDs being dragged (multi-select drag)
    dragItemIds: [],
    sourceProjectId: null,
    sourceWorkspace: null,
    // Ghost placeholder state — which project grid should show a drop ghost
    ghostProjectId: null,
    ghostInsertBeforeId: null,
    ghostItemSize: null, // { width, height } in px
  }),
  mutations: {
    START(state, { itemId, itemIds, projectId, workspace }) {
      state.active = true
      state.itemId = itemId
      state.dragItemIds = itemIds ?? [itemId]
      state.sourceProjectId = String(projectId)
      state.sourceWorkspace = workspace ?? ''
    },
    END(state) {
      state.active = false
      state.itemId = null
      state.dragItemIds = []
      state.sourceProjectId = null
      state.sourceWorkspace = null
      state.ghostProjectId = null
      state.ghostInsertBeforeId = null
      state.ghostItemSize = null
    },
    SET_GHOST(state, { projectId, insertBeforeId, itemSize }) {
      state.ghostProjectId = projectId ? String(projectId) : null
      state.ghostInsertBeforeId = insertBeforeId ?? null
      state.ghostItemSize = itemSize ?? null
    },
    CLEAR_GHOST(state) {
      state.ghostProjectId = null
      state.ghostInsertBeforeId = null
      state.ghostItemSize = null
    },
  },
}
